import { normalizeFilters } from "../../../shared/lib/normalizeFilters";

export const taskKeys = {
  all: ["tasks"] as const,
  lists: () => [...taskKeys.all, "list"] as const,
  list: (filters?: Record<string, unknown>) =>
    [...taskKeys.lists(), normalizeFilters(filters)] as const,
  detail: (id: number) => [...taskKeys.all, "detail", id] as const,
  technicianTasks: (technicianId: number, params: { from: string; to: string }) =>
    [...taskKeys.all, "technician", technicianId, params] as const,
};
